var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDiamond3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 198 171.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#46c9f7;}.cls-2{fill:#d9f7fc;}.cls-3{fill:#77dffc;}.cls-4{fill:#01aef0;}.cls-5{fill:#aeedfc;}.cls-6{fill:#0082ca;}.cls-7{fill:#0162b1;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "198 85.7 167 32 148.5 113.3 198 85.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "49.5 0 31 32 99 21.6 49.5 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "167 32 148.5 0 99 21.6 167 32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "31 32 0 85.7 49.5 113.3 31 32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "148.5 0 49.5 0 99 21.6 148.5 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "49.5 113.3 99 171.5 148.5 113.3 49.5 113.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "49.5 113.3 148.5 113.3 99 21.6 49.5 113.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "49.5 171.5 99 171.5 49.5 113.3 49.5 171.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "99 171.5 148.5 171.5 148.5 113.3 99 171.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "148.5 113.3 148.5 171.5 198 85.7 148.5 113.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "0 85.7 49.5 171.5 49.5 113.3 0 85.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "99 21.6 31 32 31 32 49.5 113.3 99 21.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "148.5 113.3 167 32 167 32 99 21.6 148.5 113.3"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiamond3);
export default __webpack_public_path__ + "static/media/diamond-3.76f644574b4122a90c1ffb3db2f1d396.svg";
export { ForwardRef as ReactComponent };